/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Bioinformatics20Inputs */

const en__field__enum_studyprograms_study_bioinformatics20 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Bioinformatics20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioinformatics`)
};

const de__field__enum_studyprograms_study_bioinformatics20 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Bioinformatics20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioinformatik`)
};

/**
* | output |
* | --- |
* | "Bioinformatics" |
*
* @param {_Field__Enum_Studyprograms_Study_Bioinformatics20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_bioinformatics20 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Bioinformatics20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Bioinformatics20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_bioinformatics20(inputs)
	return de__field__enum_studyprograms_study_bioinformatics20(inputs)
});
export { _field__enum_studyprograms_study_bioinformatics20 as "_field__enum_studyPrograms_STUDY_BIOINFORMATICS" }